import { Action, createReducer, on } from '@ngrx/store';

import { CompanyStoresActions, CompanyStoresApiActions } from './company-stores.actions';

import { CompanyStore } from './company-stores.models';

export interface CompanyStoresState {
  selectedStoreUuid: null | string;
  stores: Array<CompanyStore>;
  loading: boolean;
}

export const initialState: CompanyStoresState = {
  selectedStoreUuid: null,
  stores: [],
  loading: false,
};

const companyStoreReducer = createReducer(
  initialState,
  on(
    CompanyStoresActions.load,
    (state): CompanyStoresState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    CompanyStoresActions.select,
    (state, { storeUuid }): CompanyStoresState => ({
      ...state,
      selectedStoreUuid: storeUuid,
    })
  ),
  on(
    CompanyStoresApiActions.loadSuccess,
    (state, { stores }): CompanyStoresState => ({
      ...state,
      loading: false,
      stores: [...stores],
    })
  ),
  on(
    CompanyStoresApiActions.loadFailure,
    (state): CompanyStoresState => ({
      ...state,
    })
  )
);

export function reducer(state: CompanyStoresState | undefined, action: Action) {
  return companyStoreReducer(state, action);
}
